"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInitSearchPagePrefix = void 0;
var react_1 = require("react");
var filters_1 = require("../helpers/filters");
var store_1 = require("../app/store");
var searchParamsSlice_1 = require("../features/searchParams/searchParamsSlice");
var StructureType_1 = require("../types/SearchPage/StructureType");
var PropertyTypes_1 = require("../types/SearchPage/PropertyTypes");
var DeveloperType_1 = require("../types/SearchPage/DeveloperType");
var RentalPriceType_1 = require("../types/SearchPage/RentalPriceType");
var Localization_1 = require("../constants/Localization");
var useInitSearchPagePrefix = function (filters, seoCleanLocationSubDirectoryPrefix, hiddenStateQuery, address, selectedDistrictsData, setHiddenStateQuery, isFetchGetDistrictByName, setIsFetchGetDistrictByName, setIsDeveloperQuery, currentLanguage, setPropertyTypeQuery, setStructureTypeQuery, setRoomsQuery, setRentalPrizeQuery, deal, isPostCardClicked, addressIsRemoved) {
    var dispatch = store_1.useAppThunkDispatch();
    return react_1.useLayoutEffect(function () {
        if (filters &&
            (seoCleanLocationSubDirectoryPrefix === null || seoCleanLocationSubDirectoryPrefix === void 0 ? void 0 : seoCleanLocationSubDirectoryPrefix.length) &&
            location.pathname.search(seoCleanLocationSubDirectoryPrefix) !==
                -1 &&
            !hiddenStateQuery.state.length &&
            address &&
            (address === null || address === void 0 ? void 0 : address.search('H')) === -1 &&
            (address === null || address === void 0 ? void 0 : address.search('C')) === -1 &&
            (address === null || address === void 0 ? void 0 : address.search('B')) === -1 &&
            !addressIsRemoved) {
            var findState_1 = filters_1.getStateFilteredData(address, filters);
            var findDistrict_1 = filters_1.getDistrictFilteredData(address.toLowerCase(), selectedDistrictsData);
            if (findState_1) {
                setHiddenStateQuery(function () { return ({
                    district: [],
                    state: [String(findState_1.govId)],
                }); });
            }
            if (findDistrict_1 && !isFetchGetDistrictByName) {
                setHiddenStateQuery(function () { return ({
                    state: [],
                    district: [String(findDistrict_1.govId)],
                }); });
            }
            if (!findState_1 && !findDistrict_1 && !isFetchGetDistrictByName) {
                var trimmedAddress = address.endsWith('um')
                    ? filters_1.trimAddressNamePrefix(address)
                    : address.toLowerCase();
                address &&
                    dispatch(searchParamsSlice_1.getDistrictsByName(trimmedAddress)).then(function (response) {
                        response &&
                            setHiddenStateQuery({
                                state: [String(response.parent_state_id)],
                                district: [String(response.govId)],
                            });
                    });
                setIsFetchGetDistrictByName(!isFetchGetDistrictByName);
            }
            Localization_1.SeoCleanURLCategories.propertyTypes.apartment.filter(function (item) {
                if (seoCleanLocationSubDirectoryPrefix.search(item) > -1) {
                    setPropertyTypeQuery([PropertyTypes_1.PROPERTY_TYPE.APARTMENT]);
                }
            });
            Localization_1.SeoCleanURLCategories.propertyTypes.house.filter(function (item) {
                if (seoCleanLocationSubDirectoryPrefix.search(item) > -1) {
                    setPropertyTypeQuery([PropertyTypes_1.PROPERTY_TYPE.HOUSE]);
                }
            });
            Localization_1.SeoCleanURLCategories.propertyTypes.commercial.filter(function (item) {
                if (seoCleanLocationSubDirectoryPrefix.search(item) > -1) {
                    setPropertyTypeQuery([PropertyTypes_1.PROPERTY_TYPE.COMMERCIAL]);
                }
            });
            Localization_1.SeoCleanURLCategories.newBuilding.filter(function (item) {
                if (seoCleanLocationSubDirectoryPrefix.search(item) > -1) {
                    setStructureTypeQuery(StructureType_1.STRUCTURE_TYPE.NEW_BUILDING);
                }
            });
            Localization_1.SeoCleanURLCategories.fromDeveloper.filter(function (item) {
                if (seoCleanLocationSubDirectoryPrefix.search(item) > -1) {
                    setIsDeveloperQuery([DeveloperType_1.DEVELOPER_TYPE.True]);
                }
            });
            Localization_1.SeoCleanURLCategories.apartmentDailyPrice.filter(function (item) {
                if (seoCleanLocationSubDirectoryPrefix.search(item) > -1) {
                    setRentalPrizeQuery([
                        RentalPriceType_1.RENTAL_DAILY_PRICE_TYPE.RENTAL_PRIZE_TYPE,
                    ]);
                }
            });
            Object.keys(Localization_1.SeoCleanURLCategories.rooms).filter(function (item) {
                if (seoCleanLocationSubDirectoryPrefix.search(item) > -1) {
                    setRoomsQuery([
                        Localization_1.SeoCleanURLCategories.rooms[item],
                    ]);
                }
            });
        }
    }, [location, filters, deal, isPostCardClicked]);
};
exports.useInitSearchPagePrefix = useInitSearchPagePrefix;
